import React from 'react';
import { Breadcrumb, Input, Button } from 'antd';
import { hex_md5 } from '../../../utils/md5';

class MD5Page extends React.Component {

    constructor() {
        super();
        this.state = {
            src: '',
            dst: ''
        }
        this.onChange = this.onChange.bind(this);
        this.onClick = this.onClick.bind(this);
    }

    componentDidMount() {
    }

    onChange(type, value) {
        switch (type) {
            case 'src':
                this.setState({ src: value });
                break;
            default:
                break;
        }
    }

    onClick() {
        if (this.state.src === '') {
            this.setState({ dst: '' });
            return;
        }
        let dst = hex_md5(this.state.src);
        this.setState({ dst: dst });
    }

    render() {
        return (
            <div>
                <Breadcrumb className="breadcrumb">
                    <Breadcrumb.Item><a href="#/index">首页</a></Breadcrumb.Item>
                    <Breadcrumb.Item>MD5 加密</Breadcrumb.Item>
                </Breadcrumb>
                <div className="content">
                    <Input.TextArea autosize={{ minRows: 10, maxRows: 10 }} value={this.state.src} onChange={value => this.onChange('src', value.target.value)} />
                    <Button type="primary" style={{ marginTop: 20, marginBottom: 20 }} onClick={this.onClick}>加密</Button>
                    <Input.TextArea autosize={{ minRows: 10, maxRows: 10 }} value={this.state.dst} />
                </div>
            </div>
        );
    }

}

export default MD5Page;


// WEBPACK FOOTER //
// ./src/page/jsx/tool/MD5Page.jsx